import React, { useRef, useState } from 'react';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { Badge, IconButton } from '@mui/material';
import { Tooltip } from 'components/ui';
import { EventType, useEventSubscription } from 'context';
import { NOTIFICATION_TYPE, useNotificationCenter } from 'context/NotificationCenterContext';
import { getBellButtonSx } from './NotificationCenter.styles';
import NotificationPanel from './NotificationPanel';

const NotificationBell = () => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const { notifications, unreadCount, dismissNotification } = useNotificationCenter();
  const hasInProgress = notifications.some(
    n => !n.dismissed && n.type === NOTIFICATION_TYPE.JOB && n.status === 'in_progress'
  );
  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(prev => (prev ? null : e.currentTarget));
  };

  const handleClose = () => setAnchorEl(null);
  useEventSubscription(EventType.OPEN_NOTIFICATIONS, () => {
    if (buttonRef.current) {
      setAnchorEl(buttonRef.current);
    }
  });
  const notificationButtonLabel =
    unreadCount > 0 ? `${unreadCount} unread notification${unreadCount === 1 ? '' : 's'}` : 'Notifications';

  return (
    <>
      <Tooltip placement="bottom" title={notificationButtonLabel}>
        <span style={{ display: 'inline-flex' }}>
          <IconButton
            ref={buttonRef}
            aria-label={notificationButtonLabel}
            data-testid="notification-bell-button"
            data-notification-in-progress={hasInProgress ? 'true' : undefined}
            onClick={handleClick}
            sx={getBellButtonSx()}>
            {unreadCount > 0 ? (
              <Badge
                badgeContent={unreadCount}
                color="error"
                max={99}
                invisible={unreadCount === 0}
                slotProps={{ badge: { 'data-testid': 'notification-badge' } as React.HTMLAttributes<HTMLSpanElement> }}>
                <NotificationsIcon />
              </Badge>
            ) : (
              <NotificationsIcon />
            )}
          </IconButton>
        </span>
      </Tooltip>

      <NotificationPanel
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        notifications={notifications}
        onClose={handleClose}
        onDismiss={dismissNotification}
        showGlobalToggle
      />
    </>
  );
};

export default NotificationBell;
